import { useState } from 'react';

export function useLocalStorage<T>(key: string, initialValue: T) {
  // 获取初始值
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const item = window.localStorage.getItem(key);
      if (item === null) {
        return initialValue;
      }
      
      // 对于字符串类型，直接返回，不进行JSON.parse
      if (typeof initialValue === 'string') {
        return item as T;
      }
      
      // 对于其他类型，使用JSON.parse
      try {
        return JSON.parse(item);
      } catch (parseError) {
        // 特殊处理：如果是accessToken且解析失败，可能是纯字符串
        if (key === 'accessToken' && typeof item === 'string') {
          return item as T;
        }
        
        // 如果解析失败，返回初始值
        return initialValue;
      }
    } catch (error) {
      console.error(`Error reading localStorage key "${key}":`, error);
      return initialValue;
    }
  });

  // 返回一个包装过的setter函数，它会持久化新的值到localStorage
  const setValue = (value: T | ((val: T) => T)) => {
    try {
      // 允许值是一个函数，这样我们就有了与useState相同的API
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      
      // 对于字符串类型，直接存储，不使用JSON.stringify
      if (typeof valueToStore === 'string') {
        window.localStorage.setItem(key, valueToStore);
      } else {
        // 对于其他类型，使用JSON.stringify
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
      }
    } catch (error) {
      console.error(`Error setting localStorage key "${key}":`, error);
    }
  };

  return [storedValue, setValue] as const;
} 